module.exports = __webpack_public_path__ + "static/img/y2.76f97164.svg";